import { Action } from '@ngrx/store';
import { Account } from '../../shared/models/account.model';

export const LOADING = '[Accounts Component] Loading';
export const LOAD_ACCOUNTS = '[Accounts Component] Load Accounts';
export const LOAD_ACCOUNTS_ERROR = '[Accounts Component] Load Accounts';
export const LOAD_ACCOUNT = '[Accounts Component] Load Account';
export const LOAD_ACCOUNT_ERROR = '[Accounts Component] Load Account';
export const LOAD_ADD_ACCOUNT = '[Accounts Component] Load Add Account';
export const LOAD_ADD_ACCOUNT_ERROR = '[Accounts Component] Load Add Account Error';
export const LOAD_UPDATE_ACCOUNT = '[Accounts Component] Load Update Account';
export const LOAD_UPDATE_ACCOUNT_ERROR = '[Accounts Component] Load Update Account Error';

export const LOAD_DELETE_ACCOUNT = '[Accounts Component] Load Delete Accounts';
export const ADD_ACCOUNT = '[Accounts Component] Add Account';
export const ADD_ACCOUNTS = '[Accounts Component] Add Accounts';
export const RESET_ACCOUNT = '[Accounts Component] Reset Account';
export const DELETE_ACCOUNT = '[Accounts Component] Delete Account';
export const UPDATE_ACCOUNT = '[Accounts Component] Update Account';
export const START_EDIT_ACCOUNT = '[Accounts Component] Start Edit Account';
export const STOP_EDIT_ACCOUNT = '[Accounts Component] Stop Edit Account';

export class Loading implements Action {
  readonly type = LOADING;
  //pass endpoint to load accounts
  constructor(public payload: string) {}
}

export class LoadAccounts implements Action {
  readonly type = LOAD_ACCOUNTS;
  //pass endpoint to load accounts
  constructor(public payload: string) {}
}

export class LoadAccountsError implements Action {
  readonly type = LOAD_ACCOUNTS_ERROR;
  //pass endpoint to load accounts
  constructor(public payload: string) {}
}

export class LoadAccount implements Action {
  readonly type = LOAD_ACCOUNT;
  //pass endpoint to load accounts
  constructor(public payload: string) {}
}

export class LoadAccountError implements Action {
  readonly type = LOAD_ACCOUNT_ERROR;
  //pass endpoint to load accounts
  constructor(public payload: string) {}
}

export class LoadAddAccount implements Action {
  readonly type = LOAD_ADD_ACCOUNT;
  //pass endpoint to load accounts
  constructor(public payload: string) {}
}

export class LoadAddAccountError implements Action {
  readonly type = LOAD_ADD_ACCOUNT_ERROR;
  //pass endpoint to load accounts
  constructor(public payload: string) {}
}

export class LoadUpdateAccount implements Action {
  readonly type = LOAD_UPDATE_ACCOUNT;
  //pass endpoint to load accounts
  constructor(public payload: string) {}
}

export class LoadUpdateAccountError implements Action {
  readonly type = LOAD_UPDATE_ACCOUNT_ERROR;
  //pass endpoint to load accounts
  constructor(public payload: string) {}
}

export class LoadDeleteAccount implements Action {
  readonly type = LOAD_DELETE_ACCOUNT;
  //pass endpoint to load accounts
  constructor(public payload: string) {}
}

export class AddAccount implements Action {
  readonly type = ADD_ACCOUNT;
  //payload:  Account;
  //constructor(public payload: any) {}
  constructor(public payload: Account) {}
}

export class AddAccounts implements Action {

  readonly type = ADD_ACCOUNTS;
  constructor(public payload: Account[]) {}
}

export class UpdateAccount implements Action {
  readonly type = UPDATE_ACCOUNT;
  constructor(public payload: {index: number, account: Account}) {}
}

export class DeleteAccount implements Action {
  readonly type = DELETE_ACCOUNT;
  constructor(public payload: number) {}
}

export class ResetAccount implements Action {
  readonly type = RESET_ACCOUNT;
  payload:  [];
}

export class StartEditAccount implements Action {
  readonly type = START_EDIT_ACCOUNT;
  constructor(public payload: number) {}
}

export class StopEditAccount implements Action {
  readonly type = STOP_EDIT_ACCOUNT;
}

export type AccountListsActions = Loading |
                                  LoadAccounts |
                                  LoadAccountsError |
                                  LoadAccount |
                                  LoadAccountError |
                                  LoadAddAccount |
                                  LoadAddAccountError |
                                  LoadUpdateAccount |
                                  LoadUpdateAccountError |
                                  LoadDeleteAccount |
                                  AddAccount |
                                  AddAccounts |
                                  ResetAccount |
                                  UpdateAccount |
                                  DeleteAccount |
                                  StartEditAccount |
                                  StopEditAccount;
